import APIClient from "../client";
import { buildQueryString } from "../../utils/helpers";

const timeslotsAPI = {
  get: (query) => {
    const queryString = buildQueryString(query);
    return APIClient.get(`/slot${queryString}`);
  },
  reserveSlot: (id) => {
    return APIClient.post(`/slot/${id}`);
  },
  releaseSlot: () => {
    return APIClient.post("/slot/release");
  },
};

export default timeslotsAPI;
